import React from 'react';
import { LayoutIcon, UsersIcon, BrainIcon, BarChart3Icon, HeartPulseIcon } from 'lucide-react';
export const FeaturesSection = () => {
  return <section className="rounded-2xl overflow-hidden shadow-xl hover:shadow-2xl transition-shadow duration-300" data-id="element-29">
      <div className="bg-gradient-to-r from-[#7FE5A8] to-[#5FD88F] py-6 px-8" data-id="element-30">
        <h2 className="text-2xl font-bold text-[#1A2332] flex items-center" data-id="element-31">
          <span className="inline-block h-11 w-11 rounded-xl bg-[#1A2332] text-[#7FE5A8] flex items-center justify-center mr-4 text-lg font-bold shadow-md" data-id="element-32">
            3
          </span>
          Features
        </h2>
      </div>
      <div className="bg-white dark:bg-[#1A2332] p-10 space-y-12" data-id="element-33">
        <div data-id="element-34">
          <div className="flex items-center mb-7" data-id="element-35">
            <div className="h-10 w-10 rounded-xl bg-gradient-to-br from-[#7FE5A8] to-[#5FD88F] flex items-center justify-center mr-4 shadow-md" data-id="element-36">
              <UsersIcon className="h-5 w-5 text-[#1A2332]" data-id="element-37" />
            </div>
            <h3 className="text-xl font-semibold text-[#1A2332] dark:text-white" data-id="element-38">
              Leadership Portal (People Leaders)
            </h3>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5" data-id="element-39">
            {[{
            name: 'Dashboard',
            desc: '4C overview + Helium Score',
            icon: <LayoutIcon className="h-5 w-5" data-id="element-40" />
          }, {
            name: 'Helium Score',
            desc: '4C Index',
            icon: <BarChart3Icon className="h-5 w-5" data-id="element-41" />
          }, {
            name: 'Helium Care',
            desc: 'Coach/therapist matching',
            icon: <HeartPulseIcon className="h-5 w-5" data-id="element-42" />
          }, {
            name: 'Helium IQ',
            desc: 'AI-guided learning',
            icon: <BrainIcon className="h-5 w-5" data-id="element-43" />
          }, {
            name: 'Helium Insight',
            desc: 'Sentiment analysis',
            icon: <BarChart3Icon className="h-5 w-5" data-id="element-44" />
          }, {
            name: 'Culture Check',
            desc: 'Onboarding assessment',
            icon: <UsersIcon className="h-5 w-5" data-id="element-45" />
          }, {
            name: 'Rewards / Events',
            desc: 'Certificates Tabs',
            icon: <HeartPulseIcon className="h-5 w-5" data-id="element-46" />
          }, {
            name: 'Conflict Management',
            desc: 'Live Training',
            icon: <UsersIcon className="h-5 w-5" data-id="element-47" />
          }, {
            name: 'Hazel Workspace',
            desc: 'AI co-pilot',
            icon: <BrainIcon className="h-5 w-5" data-id="element-48" />
          }].map((feature, index) => <div key={index} className="bg-[#2A3F5F] dark:bg-[#344A66] rounded-xl p-6 hover:shadow-lg hover:bg-[#344A66] dark:hover:bg-[#3D5270] hover:scale-[1.02] transition-all duration-200" data-id="element-49">
                <div className="flex items-center mb-3" data-id="element-50">
                  <div className="h-9 w-9 rounded-xl bg-[#7FE5A8] flex items-center justify-center text-[#1A2332] mr-3 shadow-sm" data-id="element-51">
                    {feature.icon}
                  </div>
                  <h4 className="font-semibold text-base text-white" data-id="element-52">
                    {feature.name}
                  </h4>
                </div>
                <p className="text-gray-300 text-sm leading-relaxed" data-id="element-53">
                  {feature.desc}
                </p>
              </div>)}
          </div>
        </div>
        <div data-id="element-54">
          <div className="flex items-center mb-7" data-id="element-55">
            <div className="h-10 w-10 rounded-xl bg-gradient-to-br from-[#1A2332] to-[#2A3F5F] flex items-center justify-center mr-4 shadow-md" data-id="element-56">
              <UsersIcon className="h-5 w-5 text-white" data-id="element-57" />
            </div>
            <h3 className="text-xl font-semibold text-[#1A2332] dark:text-white" data-id="element-58">
              Admin Portal (Executives & HR)
            </h3>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5" data-id="element-59">
            {[{
            name: 'Dashboard',
            desc: 'Executive overview',
            icon: <LayoutIcon className="h-5 w-5" data-id="element-60" />
          }, {
            name: 'Engagement Metrics',
            desc: 'Org Health',
            icon: <BarChart3Icon className="h-5 w-5" data-id="element-61" />
          }, {
            name: 'ROI Calculator',
            desc: 'Value measurement',
            icon: <BarChart3Icon className="h-5 w-5" data-id="element-62" />
          }, {
            name: 'Reports Hub',
            desc: 'Helium Wallet',
            icon: <LayoutIcon className="h-5 w-5" data-id="element-63" />
          }, {
            name: 'Manage Licenses',
            desc: 'Experiences Tab',
            icon: <UsersIcon className="h-5 w-5" data-id="element-64" />
          }, {
            name: 'Hazel Workspace',
            desc: 'AI co-pilot assistant',
            icon: <BrainIcon className="h-5 w-5" data-id="element-65" />
          }].map((feature, index) => <div key={index} className="bg-[#2A3F5F] dark:bg-[#344A66] rounded-xl p-6 hover:shadow-lg hover:bg-[#344A66] dark:hover:bg-[#3D5270] hover:scale-[1.02] transition-all duration-200" data-id="element-66">
                <div className="flex items-center mb-3" data-id="element-67">
                  <div className="h-9 w-9 rounded-xl bg-[#7FE5A8] flex items-center justify-center text-[#1A2332] mr-3 shadow-sm" data-id="element-68">
                    {feature.icon}
                  </div>
                  <h4 className="font-semibold text-base text-white" data-id="element-69">
                    {feature.name}
                  </h4>
                </div>
                <p className="text-gray-300 text-sm leading-relaxed" data-id="element-70">
                  {feature.desc}
                </p>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
};